export const normalizeBonusesList = (bonuses) =>
  bonuses.reduce(
    (acc, bonus) => {
      const { bonusId, freespinId } = bonus;

      return {
        data: {
          ...acc.data,
          [bonusId || freespinId]: bonus
        },
        ids: [...acc.ids, bonusId || freespinId]
      };
    },
    { data: {}, ids: [] }
  );
